<template>
    <div class="px-2">
        <h5 class="text-primary mb-3">{{ $t('surgery.doseHelp.tableTitle') }}</h5>
        <table class="table table-sm ">
            <thead>
            <tr>
                <th scope="col" :class="border0"></th>
                <th scope="col" :class="border0" style="width: 5rem;"></th>
                <th scope="col" :class="helpTableClass + ' ' + border0">
                    {{ this.$t('surgery.doseHelp.factorLevel') }}
                </th>
                <th scope="col" :class="helpTableClass + ' ' + border0">
                    {{ this.$t('surgery.doseHelp.frequency') }}
                </th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <th scope="row" rowspan="2" :class="verticalAlignMiddle">
                    {{ this.$t('surgery.minorSurgery') }}
                </th>
                <td :class="verticalAlignMiddle">
                    {{ this.$t('surgery.doseHelp.preop') }}
                </td>
                <td :class="helpTableClass">50-80</td>
                <td rowspan="2" :class="helpTableClass">
                    {{ this.$t('surgery.doseHelp.minorFrequency') }}
                </td>
            </tr>
            <tr>
                <td :class="verticalAlignMiddle">
                    {{ this.$t('surgery.doseHelp.postop') }}
                </td>
                <td :class="helpTableClass">30-80</td>
            </tr>
            <tr>
                <th scope="row" rowspan="4" :class="verticalAlignMiddle">
                    {{ this.$t('surgery.majorSurgery') }}
                </th>
                <td :class="verticalAlignMiddle">
                    {{ this.$t('surgery.doseHelp.preop') }}
                </td>
                <td :class="helpTableClass" >80-100</td>
                <td :class="helpTableClass">
                    {{ this.$t('surgery.doseHelp.majorPreFrequency') }}
                </td>
            </tr>
            <tr>
                <td rowspan="3" :class="verticalAlignMiddle">
                    {{ this.$t('surgery.doseHelp.postop') }}
                </td>
                <td :class="helpTableClass">60-80</td>
                <td :class="helpTableClass">
                    {{ this.$t('surgery.doseHelp.majorPostFrequency1') }}
                </td>
            </tr>
            <tr>
                <td :class="helpTableClass">40-60</td>
                <td :class="helpTableClass">
                    {{ this.$t('surgery.doseHelp.majorPostFrequency2') }}
                </td>
            </tr>
            <tr>
                <td :class="helpTableClass">30-50</td>
                <td :class="helpTableClass">
                    {{ this.$t('surgery.doseHelp.majorPostFrequency3') }}
                </td>
            </tr>
            </tbody>
        </table>

        <h5 class="text-primary mb-3">{{ $t('surgery.doseHelp.formulaTitle') }}</h5>
        <table>
            <tr>
                <td rowspan="2">UI/kg</td>
                <td rowspan="2">=</td>
                <td class="border-bottom border-dark">
                    nivel hemostático deseado – nivel basal del FVIII del paciente
                </td>
            </tr>
            <tr>
                <td class="text-center">2</td>
            </tr>
        </table>
    </div>
</template>

<script>
    export default {
        name: "AsistencialProtocolTable",
        data() {
            return {
                helpTableClass: 'text-center',
                verticalAlignMiddle: 'align-middle',
                border0: 'border-top-0'
            };
        },
    };
</script>

<style scoped>

</style>